import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Card,
  Typography,
  Divider,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { palette } from "configurations/styles/theme";
import CompanyLogo from "views/administración/UserAccount/CompanyLogo";
import RideLogo from "views/administración/UserAccount/RideLogo";
import validations from "./validations";
import useForm from "hooks/useFrom";
import { clientPublic } from "configurations/axios";
import Alert from "widgets/alert";
//estilos
import "../Login/login.css";
import apis from "./apis";
import UseTittle from "hooks/useTitle";
import { apiKey } from "configurations/constant";
import { getRUCEmpresa } from "redux/actions/userActions";
import { useSelector } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  formLogin: {
    borderStyle: "solid",
    borderWidth: "1px",
    padding: "1%",
    borderRadius: "8px",
    marginLeft: "10px",
    marginRigth: "10px",
    borderColor: "#d9d9d9",
  },
  from: {
    width: "100%",
    margin: "1%",
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  imgRide: {
    paddingLeft: "25%",
    paddingRight: "25%",
  },
  btn: {
    paddingLeft: "25%",
    paddingRight: "25%",
  },
  section: {
    margin: "1%",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    background: "#FFFFFF",
    color: "#fafbfb",
    borderBottomColor: "#3f51b5",
    borderBottomStyle: "solid",
    marginTop: "10px",
    marginBottom: "10px",
  },
  large: {
    width: "200px",
    height: "55px",
    marginBottom: "10px",
  },
  space: {
    margin: "10px",
  },
}));

const Register = () => {
  const tokenUser = useSelector((state) => state.user.tk);
  const classes = useStyles();
  const history = useNavigate();
  const [company, setCompany] = useState({
    rucEmpresa: "",
    tipoContribuyente: "1",
    dvEmpresa: "",
    razonSocial: "",
    direccionEmpresa: "",
    correoElectronico: "",
    telefono: "",
    obligadoContabilidad: false,
    coordenadaSucursal: "",
    unificadoSucursal: "",
  });

  const [openDialog, setOpenDiaglog] = useState(false);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const [openLoader, setOpenLoader] = useState(false);
  const [location, setLocation] = useState([]);
  const [loadLocation, setLoadLocation] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState({
    idUbicacionGeografica: "",
  });

  function closeAlert() {
    setMsg({ show: false });
  }
  UseTittle({ title: " s" });

  const handleClose = () => {
    setOpenDiaglog(false);
    setCompany({
      rucEmpresa: "",
      tipoContribuyente: "",
      dvEmpresa: "",
      razonSocial: "",
      direccionEmpresa: "",
      correoElectronico: "",
      telefono: "",
      obligadoContabilidad: false,
      coordenadaSucursal: "",
      unificadoSucursal: "",
    });
    history("/");
    setLocation([]);
  };

  useEffect(() => {
    if (selectedLocation !== null) {
      setCompany({
        ...company,
        unificadoSucursal:
          selectedLocation !== null
            ? selectedLocation.idUbicacionGeografica
            : "",
      });
      getObject({
        ...company,
        unificadoSucursal:
          selectedLocation !== null
            ? selectedLocation.idUbicacionGeografica
            : "",
      });
    }
  }, [selectedLocation]);

  const existError = () => {
    setOpenLoader(false);
  };

  const handleSave = async () => {
    setOpenLoader(true);
    let resquest = {
      ...company,
      codigoSistema: apiKey,
      tipoContratacion: 1, // 1 - Prepago; 2 - Postpago
      rucEmpresaContadora: tokenUser
        ? getRUCEmpresa(tokenUser)
        : "155705519-2-2021",
    };
    await clientPublic
      .post(apis.post_save_company, resquest)
      .then((response) => {
        if (response.status >= 200 && response.status <= 300) {
          setMsg({ show: true, msg: "Empresa registrada", type: "success" });
          setOpenDiaglog(true);
        }
        setOpenLoader(false);
      })
      .catch((exception) => {
        if (exception.response) {
          if (exception.response.status === 400) {
            if (exception.response.data.apierror.lstCodigoRepuesta != null) {
              setMsg({
                show: true,
                msg: exception.response.data.apierror.lstCodigoRepuesta[0]
                  .mensaje,
                type: "error",
              });
            } else {
              setMsg({
                show: true,
                msg: "No se pudo registrar la empresa. Contáctese con el administrador del Sistema.",
                type: "error",
              });
            }
          } else if (exception.response.status === 404) {
            setMsg({
              show: true,
              msg:
                exception.response.data.apierror.mensajeSistema +
                ". Contáctese con el administrador del Sistema.",
              type: "error",
            });
          } else if (exception.response.status === 406) {
            setMsg({
              show: true,
              msg: `${exception.response.data.apierror.mensajeSistema}`,
            });
          } else if (exception.response.status === 409) {
            setMsg({
              show: true,
              msg: "La empresa ya existe. Contáctese con el administrador del Sistema.",
              type: "error",
            });
          } else {
            setMsg({
              show: true,
              msg: "Ocurrió un error interno. Contáctese con el administrador del Sistema.",
              type: "error",
            });
          }
        } else {
          setMsg({
            show: true,
            msg: "Existen problemas en la red. Contáctese con el administrador del Sistema.",
            type: "error",
          });
        }
        setOpenLoader(false);
      });
  };

  const getLocations = async () => {
    setLoadLocation(false);
    await clientPublic
      .get(apis.API_GET_ALL_LOCATIONS)
      .then((result) => {
        if (result.status === 200) {
          let locations = result.data;
          for (let i = 0; i < locations.length; i++) {
            locations[i].label =
              locations[i].nombre + " / " + locations[i].secuencial;
          }
          setLocation(locations);
        }
      })
      .catch((exception) => {
        setLocation([{ label: "Error al cargar las ubicaciones geográficas" }]);
        setMsg({
          show: true,
          msg: "Ocurrió un problema al cargar las ubicaciones geográficas.",
        });
      });
  };

  const renderLocations = () => {
    if (location.length === 0 && loadLocation) {
      getLocations();
    }
    return (
      <Autocomplete
        value={selectedLocation}
        onChange={(event, newValue) => {
          setSelectedLocation(newValue);
        }}
        options={location}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={location.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de ubicaciones geográficas"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {location.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };
  const { errors, handleSubmit, getObject } = useForm(
    handleSave,
    validations.checkCompany,
    existError
  );

  useEffect(() => {
    getObject({
      correoElectronico: "",
      direccionEmpresa: "",
      logoEmpresa: "",
      logoRide: "",
      nombreComercial: "",
      numeroResolucion: "",
      obligadoContabilidad: false,
      contribuyenteMicroEmpresa: false,
      razonSocial: "",
      rucEmpresa: "",
      telefono: "",
      agenteRetencion: "",
    });
  }, []);

  const handleChange = (event) => {
    setCompany({
      ...company,
      [event.target.name]: event.target.value,
    });
    getObject({
      ...company,
      [event.target.name]: event.target.value,
    });
  };
  const handleChangeRazonSocial = (event) => {
    setCompany({
      ...company,
      [event.target.name]: event.target.value.replace(/[&]/ig, ""),
    });
    getObject({
      ...company,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeResolucion = (event) => {
    event.preventDefault();
    const re = /[A-Za-z0-9_]/;
    if (event.target.value === "" || re.test(event.target.value)) {
      setCompany({
        ...company,
        [event.target.name]: event.target.value,
      });
      getObject({
        ...company,
        [event.target.name]: event.target.value,
      });
    }
  };

  const handleChangeCheck = (event) => {
    setCompany({
      ...company,
      [event.target.name]: event.target.value === "S" ? true : false,
    });
  };

  const handleReturnLogin = () => {
    history("/");
  };

  return (
    <>
      <Card>
        <section className={classes.title}>
          <Grid container justify="flex-start" align="center" direction="row">
            <Grid item md={12}>
              <img
                src="../facturar12020.png"
                alt="logo"
                className={classes.large}
              />
            </Grid>
          </Grid>
        </section>
        {msgError.show ? (
          <Alert
            tipo={msgError.type}
            mensaje={msgError.msg}
            mesajeSubrayado={null}
            titulo={null}
            mostrar={msgError.show}
            cerrarAlerta={closeAlert}
          />
        ) : null}
        <section>
          <form onSubmit={handleSubmit}>
            <Grid container justify="center" spacing={2}>
              <Grid item sm={8} className={classes.formLogin}>
                <Grid container spacing={1}>
                  <Grid item md={12}>
                    <Typography variant="h6">
                      <strong>Registro de empresa</strong>
                    </Typography>
                  </Grid>
                  <Grid item md={12}>
                    <Divider></Divider>
                  </Grid>
                  <Grid item md={12}>
                    <label>
                      Los campos marcados con ({" "}
                      <font color={palette.error.main}> *</font> ) son
                      obligatorios:
                    </label>
                  </Grid>
                  <Grid item sm={2}>
                    <label>
                      Ruc: <font color={palette.error.main}> *</font>
                    </label>
                  </Grid>
                  <Grid item sm={4}>
                    <input
                      type="text"
                      className={
                        errors.rucEmpresa
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChangeResolucion}
                      //required
                      name="rucEmpresa"
                      value={company.rucEmpresa}
                      placeholder="Ej. 0123456789001"
                      autoComplete="off"
                      maxLength="20"
                    />
                    {errors.rucEmpresa ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.rucEmpresa}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divForm}>
                    <label>
                      Tipo contribuyente:{" "}
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divInput}>
                    <select
                      name="tipoContribuyente"
                      className={"form-control"}
                      value={company.tipoContribuyente}
                      onChange={handleChange}
                    >
                      <option value="1">Natural</option>
                      <option value="2">Jurídico</option>
                    </select>
                  </Grid>
                  <Grid item sm={2}>
                    <label>
                      Razón Social: <font color={palette.error.main}> *</font>
                    </label>
                  </Grid>
                  <Grid item sm={4}>
                    <input
                      type="text"
                      className={
                        errors.razonSocial
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChangeRazonSocial}
                      //required
                      name="razonSocial"
                      value={company.razonSocial}
                      placeholder="Ej. Empresa C.A."
                      autoComplete="off"
                      maxLength="300" //required
                    />
                    {errors.razonSocial ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.razonSocial}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divForm}>
                    <label>
                      Dígito verificador:
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divInput}>
                    <input
                      type="number"
                      className={
                        errors.dvEmpresa
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder="Ej. 25"
                      name="dvEmpresa"
                      value={company.dvEmpresa}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {errors.dvEmpresa ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.dvEmpresa}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item sm={2}>
                    <label>
                      Correo Electrónico:
                      <font color={palette.error.main}> *</font>{" "}
                    </label>
                  </Grid>
                  <Grid item sm={4}>
                    <input
                      type="email"
                      className={
                        errors.correoElectronico
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChange}
                      name="correoElectronico"
                      value={company.correoElectronico}
                      placeholder="Ej. info@ejemplo.com.ec"
                      autoComplete="off"
                      //required
                    />
                    {errors.correoElectronico ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.correoElectronico}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item sm={3}>
                    <label>
                      Teléfono:<font color={palette.error.main}>*</font>{" "}
                    </label>
                  </Grid>
                  <Grid item sm={3}>
                    <input
                      type="text"
                      className={
                        errors.telefono
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChangeResolucion}
                      name="telefono"
                      value={company.telefono}
                      placeholder="Ej. 222-2222 ó 2222-2222"
                      autoComplete="off"
                    />
                    {errors.telefono ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.telefono}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item md={2} xs={12} className={classes.divForm}>
                    <label>
                      Coordenada sucursal:
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={4} xs={12} className={classes.divInput}>
                    <input
                      type="text"
                      className={
                        errors.coordenadaSucursal
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder="Ej. 8.982189, -79.511994"
                      name="coordenadaSucursal"
                      value={company.coordenadaSucursal}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {errors.coordenadaSucursal ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.coordenadaSucursal}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divForm}>
                    <label>
                      Código de la sucursal:
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divInput}>
                    <input
                      type="text"
                      className={"form-control is-valid"}
                      name="codigoSucursal"
                      value={"0001"}
                      disabled
                    />
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divForm}>
                    <label>
                      Ubicación geográfica:
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={9} xs={12} className={classes.divInput}>
                    {renderLocations()}
                    {errors.unificadoSucursal ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.unificadoSucursal}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item sm={3}>
                    <label>
                      Dirección: <font color={palette.error.main}> *</font>
                    </label>
                  </Grid>
                  <Grid item sm={9}>
                    <input
                      type="text"
                      className={
                        errors.direccionEmpresa
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChange}
                      name="direccionEmpresa"
                      value={company.direccionEmpresa}
                      placeholder="Ej. Av. y Calle 2"
                      autoComplete="off"
                    />
                    {errors.direccionEmpresa ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.direccionEmpresa}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item sm={6}>
                    <label>
                      Obligado a llevar Contabilidad:
                      <font color={palette.error.main}> *</font>
                    </label>
                  </Grid>
                  <Grid item sm={6}>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <RadioGroup
                        aria-label="tipoContabilidad"
                        name="obligadoContabilidad"
                        className={classes.radio}
                        value={company.obligadoContabilidad ? "S" : "N"}
                        onChange={handleChangeCheck}
                      >
                        <FormControlLabel
                          value="S"
                          control={
                            <Radio
                              color="primary"
                              className={classes.radioButton}
                            />
                          }
                          label="Si"
                          labelPlacement="start"
                          className={classes.radioLable}
                        />
                        <FormControlLabel
                          value="N"
                          control={
                            <Radio
                              color="primary"
                              className={classes.radioButton}
                            />
                          }
                          label="No"
                          labelPlacement="start"
                          className={classes.radioLable}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              justify="center"
              align="center"
              spacing={1}
              className={classes.space}
            >
              <Grid item md={1} xs={12}>
                <Button variant="contained" color="primary" type="submit">
                  Registrarse
                </Button>
              </Grid>
              &nbsp;&nbsp;
              <Grid item md={1} xs={12}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleReturnLogin}
                >
                  Cancelar
                </Button>
              </Grid>
              <br></br>
            </Grid>
            <br />
            <br />
          </form>
        </section>
        <Backdrop className={classes.backdrop} open={openLoader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Card>
      <Dialog fullWidth maxWidth="sm" open={openDialog} onClose={handleClose}>
        <DialogTitle>Registro Exitoso</DialogTitle>
        <br />
        <DialogContent>
          <Grid
            container
            spacing={2}
            justify="center"
            alignItems="center"
            align="center"
            direction="row"
          >
            <Grid item sm={12} className="alert alert-primary">
              <strong>Gracias por registrarse.</strong>
              <br />
              La información necesaria para iniciar sesión ha sido enviada al
              correo: {company.correoElectronico}
            </Grid>
            <Grid item sm={12}>
              <Button variant="contained" color="primary" onClick={handleClose}>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Register;
